import { createSlice } from "@reduxjs/toolkit";
import { customDelete } from "./delete-service";

const initialState = {
  pagination: null,
  error: [],
  loading: false,
  responseMessage: null,
  success: false,
  successMessage: null,
  deleteResponse: false,
  errorMessage: null,
};

export const deleteSlice = createSlice({
  name: "delete",
  initialState,
  reducers: {
    resetError(state) {
      state.errorMessage = null;
    },

    resetDelete(state) {
      state.successMessage = null;
    },

    resetState(state) {
      state.success = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(customDelete.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(customDelete.fulfilled, (state, action) => {
        state.responseMessage = action.payload;
        state.deleteResponse = true;
        state.successMessage = action.payload.message;
        state.loading = false;
        state.success = true;
      })
      .addCase(customDelete.rejected, (state, action) => {
        state.loading = false;
      });
  },
});
export const { resetDelete, resetState,resetError } = deleteSlice.actions;
export const error = (state) => state.error;
export const loading = (state) => state.loading;
export const deleteResponse = (state) => state.deleteResponse;
export default deleteSlice.reducer;
